import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 page-fill" }
const _hoisted_2 = { class: "flex flex-col flex-1 min-h-0 overflow-hidden" }
const _hoisted_3 = {
  class: "row w-full justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_4 = { class: "cardbody flex" }
const _hoisted_5 = { class: "flex flex-row-reverse items-center gap-3" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_8 = { class: "mt-5 table-section" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_11 = { class: "pl-4 pb-4 pr-4" }
const _hoisted_12 = { class: "w-full mt-3" }
const _hoisted_13 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_14 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_15 = { class: "flex mt-3" }
const _hoisted_16 = { class: "w-1/2" }
const _hoisted_17 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_18 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_19 = { class: "w-1/2" }
const _hoisted_20 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_21 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_22 = { class: "flex mt-3" }
const _hoisted_23 = { class: "w-1/2" }
const _hoisted_24 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_25 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_26 = { class: "w-1/2" }
const _hoisted_27 = { class: "text-sm mt-2" }
const _hoisted_28 = { class: "flex mt-3" }
const _hoisted_29 = { class: "w-1/2" }
const _hoisted_30 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_31 = { class: "flex mt-3" }
const _hoisted_32 = { class: "w-1/2" }
const _hoisted_33 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_34 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_35 = { class: "w-1/2" }
const _hoisted_36 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_37 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_38 = { class: "w-full mt-3" }
const _hoisted_39 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_40 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_41 = { class: "w-full mt-3" }
const _hoisted_42 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_43 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_44 = { class: "w-full mt-3" }
const _hoisted_45 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_46 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_47 = { class: "w-full mt-3" }
const _hoisted_48 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_49 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_50 = { class: "w-full mt-3" }
const _hoisted_51 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_52 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_53 = { class: "w-full mt-3" }
const _hoisted_54 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_55 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_56 = { class: "w-full mt-3" }
const _hoisted_57 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_58 = {
  key: 1,
  class: "text-sm mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "title" }, "Active Controls", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["flex", _ctx.tableRow.length == 0 ? 'filterButtondisabled pointer-events-none' : 'filterButton']),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
            }, [
              (_ctx.tableRow.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : (_openBlock(), _createElementBlock("img", _hoisted_7)),
              _cache[2] || (_cache[2] = _createTextVNode(" Filters "))
            ], 2)
          ])
        ])
      ]),
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-xs mt-3" }, " Data Oragnisation is the practice of categorizing and classifyinf data to make it more usable.Similar to a file folder,where we keep important documents ,you'll need to arrange your data in the most logical and orderly fashion ,so you -- and anyone else who accesses it -- can easily find what they're looking for .Data organization is the practice of categorizing and classifying data to make it more usable. Similar to a file folder, when we keep important documents,you'll need to arrange your data in the most logical and orderly fashion. ", -1)),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_tableData, {
          class: "flex-1 min-h-0",
          tableRowData: _ctx.tableRow,
          headersData: _ctx.headers,
          loadData: _ctx.dataLoading
        }, null, 8, ["tableRowData", "headersData", "loadData"]),
        (_ctx.toolTipActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showModal)
        ? (_openBlock(), _createBlock(_component_popup, {
            key: 0,
            popUp: _ctx.showModal
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "pl-2" }, "Active Control", -1)),
                _createElementVNode("button", {
                  class: "float-right text-3xl",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCancelbtn('close')))
                }, _cache[4] || (_cache[4] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: "h-5 w-5 cursor-pointer"
                  }, null, -1)
                ]))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "controllabel" }, "Control Title", -1)),
                      (_ctx.controlObject.controlTitle != undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.controlObject.controlTitle), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_14, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "controllabel" }, "CCID", -1)),
                        (_ctx.controlObject.clientUniqueId != undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.controlObject.clientUniqueId), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_18, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "controllabel" }, "Control Frequency", -1)),
                        (_ctx.controlObject.controlFrequency != undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.getControlFrequency(_ctx.controlObject.controlFrequency)), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_21, "N/A"))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "controllabel" }, "Control Class", -1)),
                        (_ctx.controlObject.controlClass != undefined && _ctx.controlObject.controlClass != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.controlObject.controlClass), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_25, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "controllabel" }, "Owner", -1)),
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.getControlOwnerName(_ctx.controlObject.controlOwner)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "controllabel" }, "Priority", -1)),
                        (_ctx.controlObject.controlPriority && typeof _ctx.controlObject.controlPriority === 'number')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorLabelBg(_ctx.controlObject.controlPriority)])
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.controlObject.controlPriority)])
                              }, _toDisplayString(_ctx.getProirityLabel(_ctx.controlObject.controlPriority)), 3)
                            ], 2))
                          : (_openBlock(), _createElementBlock("div", _hoisted_30, "N/A"))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "controllabel" }, "Control Family", -1)),
                        (_ctx.controlObject.controlFamily != undefined && _ctx.controlObject.controlFamily != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.controlObject.controlFamily), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_34, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "controllabel" }, "Control Type", -1)),
                        (_ctx.controlObject.controlType != undefined && _ctx.controlObject.controlType != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.controlObject.controlType), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_37, "N/A"))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "controllabel" }, "Control Guidance", -1)),
                      (Object.keys(_ctx.controlObject).includes('controlGuidance') && (_ctx.controlObject.controlGuidance != undefined && _ctx.controlObject.controlGuidance != ''))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.controlObject.controlGuidance), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_40, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "controllabel" }, "Audit Methodology", -1)),
                      (Object.keys(_ctx.controlObject).includes('controlAuditMethodology') && (_ctx.controlObject.controlAuditMethodology != undefined && _ctx.controlObject.controlAuditMethodology != ''))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.controlObject.controlAuditMethodology), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_43, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "controllabel" }, "Audit Success Criteria", -1)),
                      (Object.keys(_ctx.controlObject).includes('controlAuditSuccessCriteria') && (_ctx.controlObject.controlAuditSuccessCriteria != undefined && _ctx.controlObject.controlAuditSuccessCriteria != ''))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.controlObject.controlAuditSuccessCriteria), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_46, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "controllabel" }, "Policies", -1)),
                      (Object.keys(_ctx.controlObject).includes('controlPolicies') && (_ctx.controlObject.controlPolicies != undefined && _ctx.controlObject.controlPolicies != ''))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.controlObject.controlPolicies), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_49, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "controllabel" }, "Maintenance Task", -1)),
                      (Object.keys(_ctx.controlObject).includes('controlMaintenanceTask') && (_ctx.controlObject.controlMaintenanceTask != undefined && _ctx.controlObject.controlMaintenanceTask != ''))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(_ctx.controlObject.controlMaintenanceTask), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_52, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "controllabel" }, "FrameWork", -1)),
                      (Object.keys(_ctx.controlObject).includes('controlOptionFrameWork') && (_ctx.controlObject.controlOptionFrameWork != undefined && _ctx.controlObject.controlOptionFrameWork != ''))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_ctx.controlObject.controlOptionFrameWork), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_55, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "controllabel" }, "Controls", -1)),
                      (Object.keys(_ctx.controlObject).includes('frameworkControls') && (_ctx.controlObject.frameworkControls != undefined && _ctx.controlObject.frameworkControls != ''))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.controlObject.frameworkControls), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_58, "N/A"))
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["popUp"]))
        : _createCommentVNode("", true)
    ])
  ]))
}